/**
 * Estilos para SelectPaymentMethodHeader component (Fase 1 - Migración)
 *
 * 100% del theme centralizado.
 * ❌ Cero hardcodes de colores, tamaños, etc.
 * ✅ Todos los valores vienen del theme (carrefour-ui + customizaciones).
 *
 * Import desde el shim `../../../theme` (re-exporta carrefour-ui + theme personalizado).
 * Patrón: Como carrefour-checkout
 */

import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const headerStyles = {
  header: {
    marginBottom: theme.spacing.large, // 24px (antes: mb-8)
  } as CSSProperties,

  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing.medium, // 16px
  } as CSSProperties,

  title: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: theme.typography.fontSize.lg,
    lineHeight: theme.typography.lineHeight.xl,
    margin: 0,
    flex: 1,
    color: theme.colors.label,
  } as CSSProperties,

  addButton: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.base,
    color: theme.colors.button.primary,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    transition: `color ${theme.transitions.fast}`,
  } as CSSProperties,

  addButtonHover: {
    color: theme.colors.button.primaryHover,
  } as CSSProperties,

  addButtonActive: {
    color: theme.colors.button.primaryActive,
  } as CSSProperties,
} as const;
